import React from 'react';

interface LogoProps {
  height?: number | string;
  href?: string;
  aProps?: React.ComponentProps<'a'>; // Or JSX.IntrinsicElements['a']
}

const Logo: React.FC<LogoProps> = ({ height, href, aProps }: LogoProps) => (
  <a {...aProps} href={href}>
    <img
      style={{ height }}
      src="https://res.cloudinary.com/adeptdc/image/upload/v1563918620/AdeptDC%20Logos/adeptdc-primary-logo.png"
      alt="AdeptDC Logo"
    />
  </a>
);

Logo.defaultProps = {
  height: '',
  href: '/',
  aProps: {},
};

export default Logo;
